"use client";
import Link from "next/link";
import Logo from "../../ui/logo-svg";
import { usePathname } from "next/navigation";
import { useWindowScroll } from "@mantine/hooks";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import Container from "./container";

export default function Header({ isHome }: { isHome?: boolean }) {
  const [scroll, scrollTo] = useWindowScroll();
  const pathname = usePathname();
  const fullLogoRef = useRef(null);

  // Calcul de la translation avec une valeur négative pour monter - uniquement sur desktop
  // const translateY = isHome ? 0 : Math.max(-100, -scroll.y);

  return (
    <>
      <motion.div
        className={`container no-padding ${isHome ? "home" : ""} header-logo-container`}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 2,
          // transform: `translateY(${translateY}px)`,
          // transition: "transform 0.1s linear",
        }}
      >
        <div
          ref={fullLogoRef}
          className={`full-logo-header ${isHome ? "home" : ""}`}
        >
          <Link href="/">
            <Logo />
          </Link>
        </div>
      </motion.div>

      {isHome ? (
        // Navigation pour la home
        <header className={`header home-header`}>
          <div className="container no-padding">
            <div className="header-content">
              <div></div>
              <nav>
                <Link
                  className={pathname.includes("projets") ? "selected" : ""}
                  href="/projets"
                >
                  Projets
                </Link>
                <Link
                  className={pathname === "/actualites" ? "selected" : ""}
                  href="/actualites"
                >
                  Actualités
                </Link>
                <Link
                  className={pathname === "/philosophie" ? "selected" : ""}
                  href="/philosophie"
                >
                  Philosophie
                </Link>
                <Link
                  className={pathname === "/agence" ? "selected" : ""}
                  href="/agence"
                >
                  Agence
                </Link>
              </nav>
            </div>
          </div>
        </header>
      ) : (
        // Navigation pour les autres pages
        <>
          <div className="desktop-only" style={{ height: 100 }} />
          <motion.header
            className={`header ${scroll.y > 100 ? "is-white" : ""}`}
          >
            <motion.div
              className="border-animated desktop-only"
              initial={{ opacity: 0 }}
              animate={{
                opacity: scroll.y > 80 ? 1 : 0,
                // scaleX: scroll.y > 100 ? 1 : 0,
              }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                height: "1px",
                backgroundColor: "#202020",
                // transformOrigin: "left",
              }}
            />

            <Container inlineOnly>
              <div className="header-content">
                <div className="desktop-only">
                  <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    animate={{
                      opacity: scroll.y > 100 ? 1 : 0,
                      y: scroll.y > 100 ? 0 : -20,
                    }}
                    transition={{
                      duration: 0.2,
                      ease: [0.23, 1, 0.32, 1],
                    }}
                  >
                    <Link className="logo" href="/">
                      Bulle, Poirier & Justman
                    </Link>
                  </motion.div>
                </div>
                <nav>
                  <Link
                    className={pathname.includes("projets") ? "selected" : ""}
                    href="/projets"
                  >
                    Projets
                  </Link>
                  <Link
                    className={
                      pathname.includes("/actualites") ? "selected" : ""
                    }
                    href="/actualites"
                  >
                    Actualités
                  </Link>
                  <Link
                    className={pathname === "/philosophie" ? "selected" : ""}
                    href="/philosophie"
                  >
                    Philosophie
                  </Link>
                  <Link
                    className={pathname === "/agence" ? "selected" : ""}
                    href="/agence"
                  >
                    Agence
                  </Link>
                </nav>
              </div>
            </Container>
          </motion.header>
        </>
      )}
    </>
  );
}
